@if (!performance?.isBeforeToday?.() && canEditRehearsal()) {
    <div class="rehearsal-url-section">
        @if (hasRehearsalExternalUrl()) {
            <div class="rehearsal-url-content">
                <div class="rehearsal-url-label">Repetitie link</div>
                <div class="rehearsal-url-text">{{ getRehearsalExternalUrl() }}</div>
                <div class="rehearsal-url-buttons">
                    <ion-button size="small" (click)="copyRehearsalUrlToClipboard()">
                        <ion-icon name="copy-outline" slot="start" />
                        Kopieer
                    </ion-button>
                    <ion-button size="small" color="success" (click)="sendRehearsalUrlViaWhatsapp()">
                        <ion-icon name="logo-whatsapp" slot="start" />
                        WhatsApp
                    </ion-button>
                    <ion-button size="small" fill="outline" (click)="navigateToFillInRehearsal()">
                        <ion-icon name="document-text-outline" slot="start" />
                        Invullen
                    </ion-button>
                </div>
            </div>
        } @else if (canEditRehearsal()) {
            <div class="rehearsal-url-buttons">
                <ion-button size="small" fill="outline" (click)="requestRehearsalExternalUrl()" [disabled]="isGeneratingUrl">
                    @if (!isGeneratingUrl) {
                        <ion-icon name="link-outline" slot="start" />
                        {{ 'rehearsalUrl.generateButton' | translate }}
                    } @else {
                        <ion-spinner name="crescent" />
                    }
                </ion-button>
            </div>
        }
    </div>
}
